export default {
  LISTING: '/dashboard/monitoring/listing',
  CALENDAR: '/dashboard/monitoring/calendar',
  SUPPLIER: '/dashboard/monitoring/supplier',
};
